import { render } from "./Antecedente_AnteAten.vue?vue&type=template&id=372389d4"
import script from "./Antecedente_AnteAten.vue?vue&type=script&lang=js"
export * from "./Antecedente_AnteAten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__